<template>
  <div v-if="finish" class="main-content">
    <!-- 弹窗 -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-body" :class="{ 'en-mode': isEnglish }">
          <p class="modal-body-top" v-if="questionnaire && questionnaire.child">
            {{ $t('ThanksForTheInformationChild') }}
          </p>
          <p class="modal-body-top" v-else>
            {{ $t('ThanksForTheInformation') }}
          </p>
          <p>{{ $t('FeedbackIsIntroduced') }}</p>
        </div>
        <div class="modal-footer">
          <button @click="closeModal">{{ $t('know') }}</button>
        </div>
      </div>
    </div>
    <div class="top-title">
      <LangRadio ref="langRadio" @query="query" :visible-more-lang="visibleMoreLang" />
    </div>
    <div class="container">
      <!-- 住院评价部分开始 -->
      <div v-if="episodeType === 2" class="date_box">
        <div class="date_item">
          <div>
            <p class="date_title">{{ $t('Feedback') }}</p>
          </div>
          <div class="date_top">
            <span>{{ $t('dischargeDate') }}：</span>
            <span>{{ questionnaire.leaveHospitalDate }}</span>
          </div>
          <div class="date_bottom">
            <span>{{ $t('ward') }}：</span>
            <span>{{ questionnaire.bedNumber }}</span>
          </div>
        </div>
      </div>
      <!-- 空div样式 -->
      <div v-if="episodeType === 2" class="style_box"></div>
      <!-- 住院进度条 -->
      <div class="step_box" v-if="episodeType === 2">
        <div class="step_box_title">
          <div class="step_list" :class="{ list_active: nursingShow === 0 }">
            <span class="step_i">
              ①
            </span>
            <span class="step_span">
              {{ $t("TheServiceRate") }}
            </span>
          </div>
          <div class="step_list" :class="{ list_active: nursingShow === 1 }">
            <span class="step_i">
              ②
            </span>
            <span class="step_span">{{ $t("nursingEvaluation") }}</span>
          </div>
          <div class="step_list" :class="{ list_active: nursingShow === 2 }">
            <span class="step_i">
              ③
            </span>
            <span class="step_span">{{ $t("complete") }}</span>
          </div>
        </div>
      </div>
      <!-- 门诊评价-->
      <div v-if="!nursingShow">
        <template v-if="episodeType !== 2">
          <!-- doctorIno 医生信息对象必须存在且不为空 就诊类型不是住院 -->
          <div v-if="doctorIno && episodeType != EPISODE_TYPE.IP" class="doctorLi">
            <div class="doctorImg-wrapper">
              <div class="doctorImg">
                <h3 class="title">{{ $t('Feedback') }}</h3>
                <div class="topDiv">
                  <span class="time-wrap">
                    <i class="timeIcon" />{{ episodeDate }}
                  </span>
                  <span class="visitedClass">
                    <span>{{ $t("visited") }}</span>
                  </span>
                </div>
                <ul class="infoUl">
                  <li>
                    <span>{{ $t("department") }}：</span>
                    <span class="value">{{ doctorIno.deptName }}</span>
                  </li>
                  <li>
                    <span>{{ $t("location") }}：</span>
                    <span class="value">{{ doctorIno.siteName }}</span>
                  </li>
                  <li>
                    <span>{{ $t("patient") }}：</span>
                    <span class="value">{{ doctorIno.patientName }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="style_box" style="margin-top: 15px;"></div>
          <div v-for="item in list" :key="item.groupType" class="inDepartment">
            <h2>
              {{ item.groupName }}
            </h2>
            <ul class="controls">
              <li v-for="(cItem, cIndex) in item.satisfactionList" :key="cIndex">
                <h3>
                  {{ cIndex + 1 }}.{{ cItem.qsContent }}
                </h3>
                <div style="display: flex; align-items: center;margin: 20px 0 40px 0;">
                  <ul style="flex: 1">
                    <v-rate v-if="cItem.qsTotalScore > 0" :list="dict" :total="cItem.qsTotalScore"
                      :value="solution[cItem.id] ? Math.ceil(solution[cItem.id].score / 2) : 0"
                      @change="(sIndex) => { setSolution(cItem, sIndex); }" />
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <div class="inDepartment">
            <ul class="controls">
              <li style="margin-bottom: 15px;">
                <h3>
                  {{ list.reduce((count, item) => count + item.satisfactionList.length, 0) + 1 }}.{{
                  $t("otherQuestions") }}
                </h3>
              </li>
            </ul>
          </div>
        </template>
        <template v-if="episodeType === 2">
          <div style="background: #fff;">
            <div v-for="item in list" :key="item.groupType" class="hospital_inDepartment">
              <div class="list_title">
                <img :src="require('../assets/images/ask.png')" class="ask-icon" />
                <h2>
                  {{ item.groupName }}
                </h2>
              </div>
              <ul class="controls">
                <li v-for="(cItem, cIndex) in item.satisfactionList" :key="cIndex">
                  <h3>
                    {{ cItem.qsContent }}
                  </h3>
                  <div style="display: flex; align-items: center;margin: 20px 0 30px 0;">
                    <ul style="flex: 1">
                      <v-rate v-if="cItem.qsTotalScore > 0" :list="dict" :total="cItem.qsTotalScore"
                        :value="solution[cItem.id] ? Math.ceil(solution[cItem.id].score / 2) : 0"
                        @change="(sIndex) => { setSolution(cItem, sIndex); }" />
                    </ul>
                  </div>
                  <!-- 分割线 -->
                  <div v-if="cIndex < item.satisfactionList.length - 1" class="question-divider-wrapper">
                    <div class="question-divider"></div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="hospital_inDepartment" style="margin-bottom: 0 !important;">
              <div class="list_title">
                <img :src="require('../assets/images/ask.png')" class="ask-icon" />
                <h2>
                  {{ $t('otherQuestions') }}
                </h2>
              </div>
            </div>
          </div>
        </template>
        <!-- 公用 表扬投诉输入框 下一步提交 -->
        <div class="feedback-list">
          <!-- 表扬投诉 -->
          <div class="feedback-type" :style="{ 'border-radius': episodeType === 2 ? '0' : '14px 14px 0 0' }">
            <ul class="feedback-options">
              <li v-for="(type, index) in feedbackTypes" :key="index"
                :class="{ active: form.evaluationType === type.value }" @click="form.evaluationType = type.value">
                <img
                  :src="form.evaluationType === type.value
                    ? (type.value === 1 ? require('../assets/images/praise_green.png') : require('../assets/images/complaint_red.png'))
                    : (type.value === 1 ? require('../assets/images/praise_gray.png') : require('../assets/images/complaint_gray.png'))"
                  :alt="type.label" class="feedback-icon" />
                {{ type.label }}
              </li>
            </ul>
          </div>
          <!-- 表扬投诉结束 -->
          <!-- 输入框 -->
          <div class="remark">
            <div class="textarea-wrapper">
              <textarea v-model.trim="form.satisfactionRemark" :placeholder="$t('contextPlaceholder')" maxlength="300"
                @focus="() => onSoftkeyboardShown(true)" @blur="() => onSoftkeyboardShown(false)" />
              <div class="char-count">
                {{ form.satisfactionRemark ? form.satisfactionRemark.length : 0 }}/300
              </div>
            </div>
          </div>
          <!-- 输入框结束 -->
        </div>
        <!-- 下一步下一步 -->
        <div v-if="episodeType === 2" class="btn-box">
          <button @click="submit">
            {{ $t("nextStep") }}
          </button>
        </div>
        <!-- 提交 -->
        <div v-else class="btn-box">
          <button @click="submit">
            {{ $t("submit") }}
          </button>
        </div>
      </div>
      <!-- 护理评价  显示医生评价部分,为1 或者true的时候 显示护理评价组件 -->
      <nursing-evaluation v-else :satisfaction-source="satisfactionSource" :questionnaire="questionnaire"
        @JumpMode="JumpMode" />
    </div>

    <div v-if="isAndroid" :style="{ height: softkeyboardHeight }"></div>
  </div>
</template>

<script>
import LangRadio from '../components/LangRadio.vue';
import { DateFtt, checkPhone, checkEmail } from '../utils';
import APIS from '../helpers/APIS';
import {
  SATISFACTIONSTATUS,
  EPISODE_TYPE,
  NURSINGGROUP
} from '../helpers/CONSTANTS';
import { axPost, axGet } from '../helpers';
import VRate from '../components/Rate';
import nursingEvaluation from '../components/NursingEvaluation';
import device from '../utils/device'

export default {
  name: 'Index',
  components: { LangRadio, VRate, nursingEvaluation },
  data() {
    return {
      showModal: false,
      EPISODE_TYPE,
      id: '',
      nursingShow: 0, // 护理页面显示
      defaultDoctor: require('../assets/images/default_doctor.png'),
      score: 0,
      doctorIno: {}, // 医生信息
      dict: [],
      groupSatisfactionList: [], // 问题列表
      solution: {}, // 答案: { id, score, label }，label在提交时应删除
      episodeTips: '',
      episodeType: '', // 就诊人类型
      form: {
        name: '',
        mobile: '',
        mail: '',
        satisfactionRemark: '',
        evaluationType: '' // 评价
      },
      questionnaire: '',
      satisfactionStatus: '', // 评价状态
      satisfactionSource: '', // 设备标识
      hospitalSubmitStatus: 0, // 展示状态0，提一半，1提交结束
      submitFinishStatus: 1, // 提交状态，首次提交 0，最终提交 1
      callBackUrl: '',
      finish: false,
      visibleMoreLang: false, // 显示更多语言（日韩）
      softkeyboardHeight: 0, // 在android上输入框获取焦点要底部增加一个高度
      isAndroid: device.android && !device.miniProgram,
      isSubmitting: false
      };
  },
  computed: {
    list() {
      // 过滤数据
      const filteredList = this.groupSatisfactionList.filter((item) => {
        return (
          item.groupType !== NURSINGGROUP.BASICSERVICES &&
          item.groupType !== NURSINGGROUP.PAINMANAGEMENT
        );
      });
      // 只有住院类型(episodeType === 2)才需要排序
      if (this.episodeType === 2) {
        return filteredList
          // 对问题组按 groupSort 排序
          .sort((a, b) => {
            const sortA = a.groupSort !== undefined ? a.groupSort : Infinity;
            const sortB = b.groupSort !== undefined ? b.groupSort : Infinity;
            return sortA - sortB;
          })
      }
      // 门诊类型不需要排序，直接返回过滤后的列表
      return filteredList;
    },
    episodeDate () {
      const value = this.doctorIno.episodeTime;
      if (value) {
        return DateFtt('yyyy-MM-dd hh:mm', new Date(value));
      }
      return '';
    },
    feedbackTypes() {
      return [
        { value: 1, label: this.$t('praise') },
        { value: 0, label: this.$t('complaints') }
      ]
    },
    isEnglish () {
      return this.$i18n.locale === 'en';
    },
    langZh () {
      return this.$i18n.locale === 'zh'
    }
  },
  watch: {
    'form.mobile' () {
      if (this.form.mobile.length > 16) {
        this.form.mobile = this.form.mobile.slice(0, 16);
      }
    },
    groupSatisfactionList () {
      for (let k in this.solution) {
        let sObj = this.solution[k];
        let inNewDict = this.dict.find((dItem) => dItem.value === sObj.score);
        inNewDict && (this.solution[k].label = inNewDict.label);
      }
    }
  },
  created () {
    this.init();
  },
  methods: {
    async init () {
      try {
        const { id } = this.$route.query;
        if (!id) {
          alert(this.$t('SystemException'));
          return;
        }

        const { data = {} } = await axGet(APIS.MORE_LANG, { episodeCode: id })
        const moreLang = data.data;
        if (moreLang) {
          this.visibleMoreLang = moreLang;
        } else {
          /**
           * 如果不展示更多语言，并且选中的语言为日韩则设置默认为中文语言
           */
          const currentLang = localStorage.getItem('locale');
          if (['ja', 'ko'].includes(currentLang)) {
            localStorage.setItem('locale', 'zh');
          }
        }
        this.finish = true;

        await this.query()

        if (this.satisfactionStatus === SATISFACTIONSTATUS.ALREADY_EVALUATED) {
          this.JumpMode();
        }
      } catch (e) {
        this.finish = true;
      }
    },
    JumpMode (data) {
      const { callback } = this.$route.query;
      if (callback) {
        window.location.href = callback;
      } else {
        this.$router.replace({
          name: 'success',
          query: { couponInfo: JSON.stringify(data), moreLang: Number(!!this.visibleMoreLang),isHospital: this.episodeType === 2 ? 1 : 0 }
        });
      }
    },
    setSolution (item, sIndex) {
      // 设置题目答案
      const dict = this.dict || [];
      // 将1-5的评分转换为1-10的分数
      const score = sIndex * 2 ; // 转成 2 4 6 8 10

      const satisfactionItem = {
        id: item.id,
        score: score,
      };

      let obj = {};
      obj[item.id] = satisfactionItem;
      this.$set(this, 'solution', { ...this.solution, ...obj });
    },
    isRespondence (satisfaction, solutionArr) {
      const solutionLen = solutionArr.length
      for (let i = 0; i < solutionLen; i++) {
        if (satisfaction.id === solutionArr[i].id) {
          return true;
        }
      }
      return false;
    },
    // 就诊满意度问卷(打开/初始化问卷信息)
    async query () {
      const { id, satisfactionSource } = this.$route.query;
      this.id = id;
      this.satisfactionSource = satisfactionSource || '';
      try {
        const {
          data: { msg, code, data }
        } = await axGet(APIS.DETAIL, {
          episodeCode: id,
          satisfactionSource: this.satisfactionSource
        });
        if (code === 0 && data) {
          const {
            episodeType,
            hospitalSubmitStatus,
            episodeInfo,
            groupSatisfactionList = [],
            episodeScoreInfo,
            episodeTips,
            satisfactionStatus,
            mail,
            mobile,
            name
          } = data;
          this.questionnaire = data;
          this.doctorIno = episodeInfo;
          this.episodeType = episodeType;
          this.groupSatisfactionList = groupSatisfactionList;
          this.dict = episodeScoreInfo;
          this.episodeTips = episodeTips;
          this.satisfactionStatus = satisfactionStatus;
          this.hospitalSubmitStatus =
            hospitalSubmitStatus || SATISFACTIONSTATUS.NOT_EVALUATED;
          this.form.name = name;
          this.form.mobile = mobile;
          this.form.mail = mail;
          if (
            this.episodeType === EPISODE_TYPE.IP &&
            satisfactionStatus === SATISFACTIONSTATUS.NOT_EVALUATED
          ) {
            this.nursingShow =
              hospitalSubmitStatus || SATISFACTIONSTATUS.NOT_EVALUATED;
          }
          if (this.episodeType === 2) {
            this.showModal = true;
          }
        } else {
          alert(msg);
        }
      } catch (e) {
        //
      }
    },
    async submit () {
      if (this.isSubmitting || !this.groupSatisfactionList || this.groupSatisfactionList.length === 0) {
        return;
      }
      this.isSubmitting = true;
      // 提交
      let formData = {};
      const { id, callback, userId } = this.$route.query;
      this.id = id;
      const solutionArr = Object.values(this.solution);
      // 检查是否有题目未作答
      let isRespondence = true;
      const groupSatisfactionLen = this.groupSatisfactionList.length;
      for (let o = 0; o < groupSatisfactionLen; o++) {
        let groupSatisfaction = this.groupSatisfactionList[o];
        const satisfactionLen = groupSatisfaction.satisfactionList.length;
        if (
          isRespondence &&
          groupSatisfaction.groupType !== NURSINGGROUP.BASICSERVICES &&
          groupSatisfaction.groupType !== NURSINGGROUP.PAINMANAGEMENT
        ) {
          for (let i = 0; i < satisfactionLen; i++) {
            let satisfaction = groupSatisfaction.satisfactionList[i];
            if (isRespondence && satisfaction.qsRequired === 1) {
              isRespondence = this.isRespondence(satisfaction, solutionArr);
            }
          }
        }
      }
      if (!isRespondence) {
        alert(this.$t('errSolution'));
        this.isSubmitting = false;
        return;
      }
      formData = { ...this.form };
      this.groupSatisfactionList.forEach((item) => {
        if (
          this.episodeType === EPISODE_TYPE.IP &&
          (item.groupType === NURSINGGROUP.BASICSERVICES ||
            item.groupType === NURSINGGROUP.PAINMANAGEMENT)
        ) {
          this.submitFinishStatus = 0;
        }
      });
      if (this.episodeType === EPISODE_TYPE.IP) {
        formData.submitFinishStatus = this.submitFinishStatus;
      }
      formData.satisfactionList = JSON.stringify(
        Array.from(solutionArr, (item) => ({ id: item.id, score: item.score }))
      );
      formData.satisfactionMethod = 2;
      formData.episodeCode = id;
      formData.userId = userId;
      formData.satisfactionSource = this.satisfactionSource;
      // 备注设置
      formData.satisfactionRemark = this.form.satisfactionRemark;
      formData.evaluationType = this.form.evaluationType
      formData.callback = callback;
      try {
        const { data: { msg, code, data } } = await axPost(APIS.SUBMIT, formData);
        if (code === 0) {
          if (this.episodeType === EPISODE_TYPE.IP) {
            this.nursingShow = SATISFACTIONSTATUS.ALREADY_EVALUATED
            window.scrollTo(0, 0)
            this.isSubmitting = false;
          } else {
            this.JumpMode(data)
          }
        } else {
          alert(msg)
          this.isSubmitting = false;
        }
      } catch (e) {
        this.isSubmitting = false;
        //
      }
    },
    onSoftkeyboardShown (show) {
      this.softkeyboardHeight = show ? '38vh' : '0'
      if (show) {
        this.$nextTick(() => {
          window.scrollTo(0, document.body.scrollHeight)
        })
      }
    },
    closeModal () {
      this.showModal = false
    }
  }
};
</script>

<style lang="less">
.date_box {
  padding: 0 30px;
  margin-bottom: 20px;
}

.date_item {
  background-image: url('../assets/images/hospitalization.png');
  width: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  height: 386px;

  .date_title {
    padding: 100px 30px 0 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #174169;
    font-size: 26px;
  }

  .date_top {
    padding: 0 0 0 80px;
    margin: 63px 0 14px 0;
    font-weight: 500;
    font-size: 28px;
    color: #36444E;
  }

  .date_bottom {
    padding: 0 0 0 80px;
    font-weight: 500;
    font-size: 28px;
    color: #36444E;
    font-family: PingFangSC, PingFang SC;
  }
}

.main-content {
  background: linear-gradient(321deg, #FFFFFF 0%, #EEFAFF 100%);
  background-size: 100% auto, 0 0;
  width: 750px;
  min-height: 100vh;
  padding-top: 30px;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 28px;
  color: @langColor;
  position: relative;

  .btn-box {
    text-align: center;
    background: #fff;
    padding: 40px 0 calc(42px + env(safe-area-inset-bottom));

    button {
      width: 690px;
      height: 90px;
      background: linear-gradient(135deg, #7BECD3 0%, #45D4A8 100%);
      border-radius: 45px;
      outline: none;
      border: none;
      font-size: 32px;
      text-align: center;
      font-weight: 500;
      color: #ffffff;
    }
  }

  input,
  textarea {
    /*width: 100%;*/
    border: none;
    text-align: right;
    outline: none;
    font-size: 32px;
    color: #44434a;
    -webkit-appearance: none;

    &::-webkit-input-placeholder {
      /* WebKit browsers */
      font-weight: 400;
      font-size: 28px;
      color: #C6CDD2;
    }

    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #999;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color: #999;
    }
  }

  .remark {
    background: #F6F8FB;
    padding: 30px 30px;
    position: relative;
    border-radius: 0 0 14px 14px;

    .textarea-wrapper {
      position: relative;
    }

    textarea {
      border-radius: 14px;
      text-align: left;
      padding: 28px 30px;
      height: 189px;
      min-height: 200px;
      max-height: 200px;
      width: 570px;
      padding-bottom: 30px;
    }

    .char-count {
      position: absolute;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 26px;
      color: #C6CDD2;
      right: 10px;
      bottom: 20px;
      pointer-events: none;
      background: #fff;
      padding: 5px 10px;
      border-radius: 4px;
    }
  }

  .commitInfo {
    background: #fff;
    color: #44434a;
    font-size: 32px;

    li {
      padding: 22px 0;
      margin: 0 30px;
      display: flex;
      border-bottom: 1px solid #e0e0e0;

      &:last-child {
        border-bottom: 0;
      }

      span {
        // width: 230px;
        padding-right: 20px;
      }

      div {
        flex: 1;
        overflow: hidden;

        input {
          width: 100%;
          padding: 0;
        }
      }
    }
  }

  .inDepartment {
    .controls {
      border-radius: 40px 40px 0px 0px;
    }

    h2 {
      font-size: 36px;
      font-weight: bold;
      color: #19cc9f;
      padding: 6px 30px 0;
    }
  }

  .hospital_inDepartment {
    background: #fff;
    padding: 0 30px;
    margin-bottom: 30px;

    .controls {
      background: #F6F8FB;
      border-radius: 0 0 20px 20px;
    }

    .list_title {
      padding: 0 30px;
      background: #EEF1F4;
      height: 97px;
      display: flex;
      align-items: center;
      border-radius: 20px 20px 0px 0px;
    }

    .ask-icon {
      width: 40px;
      height: 32px;
      margin-right: 10px;
    }

    h2 {
      font-weight: 500;
      font-size: 30px;
      color: #48C9EF;
    }

    ul.controls {
      >li {

        h3 {
          font-weight: 400;
          font-size: 28px;
          color: #1D272D;
          padding-bottom: 10px;
        }
      }
    }

  }

  ul.controls {
    &.pt-52 {
      padding-top: 52px;
    }

    padding: 32px 30px 0;
    background: #fff;
    overflow: hidden;

    >li {
      h2 {
        font-size: 36px;
        color: #19cc9f;
        padding: 70px 0 30px;
      }
      margin-bottom: 30px;
      h3 {
        font-weight: 400;
        font-size: 28px;
        color: #000000;
        padding-bottom: 10px;
      }

      ul {
        height: 44px;
        margin-top: 24px;
        display: flex;
        justify-content: left;
        align-items: center;

        li {
          margin-right: 50px;
          overflow: hidden;
          width: 44px;
          height: 44px;
          color: #666;
          font-size: 28px;
          vertical-align: middle;

          &::after {
            content: "";
            display: block;
            width: 100%;
            height: 100%;
            background: transparent url("../assets/images/unchecked.png") no-repeat;
            background-size: 44px 44px;
          }

          &.active::after {
            background-image: url("../assets/images/checked.png");
          }

          &:last-child {
            width: auto;
            position: relative;
            top: 1px;

            &::after {
              content: none;
            }
          }
        }
      }
    }
  }


  .top-title {
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
  }

  .title-wrap {
    padding: 0 30px;
    color: #ffffff;
    position: relative;

    .logo {
      width: 186px;
      height: 38px;
      top: 0;
      right: 30px;
      position: absolute;
    }

    h2 {
      font-size: 48px;
      font-weight: 600;
      padding-top: 8px;
    }

    span {
      padding-top: 15px;
      display: block;
      height: 50px;
      font-size: 36px;
      font-weight: 400;
      line-height: 50px;
    }
  }

  &>div.container {
    .doctorLi {
      color: #44434a;
      font-size: 28px;

      .doctorImg-wrapper {
        padding: 0 30px;
        position: relative;

        .title {
          padding: 80px 30px 0 180px;
          height: 32px;
          font-family: FZZZHONGJW--GB1, FZZZHONGJW--GB1;
          font-size: 26px;
          line-height: 32px;
          color: #174169;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .paddingtop{
          padding: 80px 30px 0 180px;
        }
      }

      .doctorImg {
        background-image: url('../assets/images/information_bg.png');
        width: 100%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        min-height: 407px;
      }

      .infoUl {
        margin: 14px 60px 0;

        li {
          font-size: 28px;
          font-weight: 400;
          text-align: left;
          color: #36444E;
          display: flex;
          margin-bottom: 14px;
          word-break: break-all;
          span:first-child {
            flex-shrink: 0;
            white-space: nowrap;
          }

          .value {
            flex: 1;
            padding-left: 10px;
            overflow: hidden;
            word-break: break-all;
            white-space: nowrap;
            text-overflow: ellipsis;
            }
          &:last-child {
            padding-bottom: 30px;
          }
        }
      }

      .topDiv {
        position: relative;
        margin: 47px 60px 0;
        height: 40px;
        text-align: left;
        line-height: 40px;

        .visitedClass {
          position: absolute;
          top: -27px;
          right: -39px;
          padding: 0 14px;
          border-radius: 0px 19px 0px 16px;
          background-color: #fff;
          opacity: 0.89;
          color: #45D4A8;
          font-size: 24px;
          font-weight: 400;
        }

        .time-wrap {
          display: flex;
          align-items: center;
        }

        .timeIcon {
          background: url("../assets/images/timeIcon.png") no-repeat;
          width: 28px;
          height: 28px;
          background-size: 100% 100%;
          display: block;
          margin-right: 20px;
        }
      }
      border-radius: 40px 40px 0 0;
    }
  }

  .style_box {
    height: 20px;
    background: #E5F8F4;
    filter: blur(12px);
  }

  .step_box {
    padding: 30px;
    background-color: #fff;
    border-radius: 40px 40px 0px 0px;

    .step_box_title {
      border-radius: 20px;
      display: flex;
      box-sizing: border-box;
      background: #ECFBFF;
      align-items: flex-end;
      position: relative;
      height: 86px;

      .step_list {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33%;
        font-size: 28px;
        color: #86949E;
        font-weight: 400;
        height: 86px;
        padding: 0 10px;
      }

      .step_i {
        margin-right: 5px;
      }

      .step_span {
        flex-wrap: nowrap;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .list_active {
        background: url("../assets/images/steps.png") no-repeat;
        background-size: 100% 100%;
        font-weight: 500;
        font-size: 28px;
        color: #36444E;
        padding-bottom: 9px;
        position: relative;
        top: 9px;
        z-index: 1;
      }
    }
  }
}

.feedback-list {
  display: block;
  background-color: #fff;
  padding: 0 30px;
}

.feedback-type {
  background: #F6F8FB;
  padding: 30px 30px 0;

  .feedback-options {
    display: flex;

    li {
      padding: 9px 17px;
      border: 1px solid #979797;
      border-radius: 10px;
      margin-right: 15px;
      cursor: pointer;
      font-weight: 400;
      display: flex;
      line-height: 37px;
      font-size: 26px;
      color: #000000;
      align-items: flex-end;

      .feedback-icon {
        width: 32px;
        height: 32px;
        margin-right: 5px;
      }

      &.active {
        color: #45D4A8;
        font-size: 26px;
        font-weight: 500;
        background: linear-gradient(180deg, rgba(217, 255, 247, 0.08) 0%, rgba(25, 255, 184, 0.19) 100%);
        border-radius: 10px;
        border: 2px solid #45D4A8;
      }
    }
  }
}

// 弹窗样式
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  width: 634px;
  max-width: 90%;
}


.modal-body {
  text-align: center;
  background: url("../assets/images/pop-up.png") no-repeat;
  width: 634px;
  height: 658px;
  background-size: 100% 100%;
  display: block;

  &.en-mode {
    height: 750px;
  }

  .modal-body-top {
    padding-top: 270px;
    margin-bottom: 30px;
  }

  p {
    font-weight: 400;
    font-size: 28px;
    color: #1C5265;
    padding: 0 50px;
    text-align: left;
  }
}

.modal-footer {
  text-align: center;
  margin-top: 60px;

  button {
    width: 400px;
    height: 90px;
    background: linear-gradient(135deg, #7BECD3 0%, #45D4A8 100%);
    border-radius: 45px;
    border: none;
    color: #fff;
    font-size: 32px;
    font-weight: 500;
  }
}
.question-divider-wrapper {
  padding: 20px 0 0 0;

  .question-divider {
    border-top: 1px solid #E6E6E6;
  }
}
</style>
